import { GdsService_OrderAdditionalServiceGdsServiceVip_Fragment } from '@websky/graphql';
import { useState, useEffect, useMemo } from 'react';
import { State as AllServicesState } from '../../TransferService/model';
import { initialStateFactory } from './initialStateFactory';
import { useMethods } from './methods';
import { useVariables } from './variables';

export * from './types';

export const useTransferSelector = (
	service: GdsService_OrderAdditionalServiceGdsServiceVip_Fragment,
	parentState: AllServicesState['services'],
	isOpen: boolean
) => {
	const [state, setState] = useState(initialStateFactory(service, parentState));
	const methods = useMethods(state, setState, service, parentState);
	const variables = useVariables(state, service);

	const [initialState, setInitialState] = useState(state);

	useEffect(() => {
		if (isOpen) {
			setInitialState(state);
		}
	}, [isOpen]);

	const isDirty = useMemo(() => {
		for (const passengerId in state) {
			for (const serviceId in state[passengerId]) {
				if (state[passengerId][serviceId]?.selected !== initialState[passengerId][serviceId]?.selected) {
					return true;
				}
			}
		}

		return false;
	}, [state, initialState]);

	return {
		state,
		isDirty,
		setState,
		toggleService: methods.onToggle,
		restoreState: methods.restoreState,
		removeTransfer: methods.removeTransfer,
		totalPrice: variables.totalPrice,
		minPrice: variables.minPrice
	};
};
